<div class="pnl-settings-banners">
  <header>
      <a [routerLink]="['/app/configuracao/design']" class="back">Design da loja</a>
      <h1>Banners</h1>
      <a [routerLink]="['/app/configuracao/design/banners/'+local_slug+'/cadastro']" class="add">Cadastrar</a>
  </header>
  <section>
    <form [formGroup]="bannerFrm" (ngSubmit)="onSubmit()" novalidate class="dnone">
      <div class="banners-config">
        <h3>Configuração</h3>
        <div>
          <mat-radio-group formControlName="banner_tipo" (change)="onChangeDetail()">
            <mat-radio-button name="banner_tipo" value="P">Padrão</mat-radio-button>
            <mat-radio-button name="banner_tipo" value="R">Linear rotativo</mat-radio-button>
          </mat-radio-group>
          <div *ngIf="banner_tipo.value == 'R'" class="banners-forms">
            <div class="frm fdc">
              <label>Intervalo de movimentação</label>
              <div class="frm-row">
                <input type="text" formControlName="banner_intervalo" (keyup)="onChangeDetail()" currencyMask [options]="{ precision: 0, allowNegative: false }" class="form-control">
                <span>segundos</span>
              </div>
            </div>
            <div class="frm fdc">
              <label>Número de colunas</label>
              <div class="frm-row">
                <input type="text" formControlName="banner_colunas" (keyup)="onChangeDetail()" currencyMask [options]="{ precision: 0, allowNegative: false }" class="form-control">
              </div>
            </div>
          </div>
        </div>
        <div>

        </div>
      </div>
    </form>
    <div class="banners-actions">
      <div *ngIf="banners.length > 0">
        <mat-checkbox [(ngModel)]="allSelected" (change)="onSelectAll()">Selecionar todos</mat-checkbox>
      </div>

      <div class="region">
        <label>Filtrar por região</label>
        <ng-select [items]="regions" (change)="onFilter()"  (clear)="onClearRegion()" [(ngModel)]="local" placeholder="Selecione" bindLabel="descricao" bindValue="local"></ng-select>
      </div>

      <div *ngIf="banners.length > 0">
        <button (click)="onDeleteBanner()" class="btn" [class.btn-danger-outline]="canDelete" [disabled]="!canDelete">Apagar</button>
      </div>
    </div>
    <div cdkDropList class="banners-list" (cdkDropListDropped)="drop($event)">
        <div class="banners-box" *ngFor="let banner of banners; let i=index" cdkDrag [cdkDragDisabled]="local==''" [class.banner-box-disabled]="false">
            <div class="banners-ck">
              <mat-checkbox [(ngModel)]="banner.selected" (change)="onSelect()"></mat-checkbox>
            </div>
            <div class="cdkDragHandle" cdkDragHandle [class.selected]="banner.selected" [class.disabled]="local==''"><i class="ic ic-dots"></i></div>
            <div class="banners-custom-placeholder" *cdkDragPlaceholder></div>
            <div [routerLink]="['/app/configuracao/design/banners/cadastro/'+banner.idbanner]" class="banners-data" [class.selected]="banner.selected">
              <div class="banners-infos">
                <strong>{{ banner.titulo == null ? 'Banner sem título' : banner.titulo }}</strong>
                <span *ngIf="banner.posicao">{{ banner.posicao }} posição na região {{banner.local_ds}}</span>
              </div>
              <div class="banners-status">
                <span *ngIf="banner.dt_expiracao && banner.dt_expiracao_days > 1">Expira em {{banner.dt_expiracao_days}} dias</span>
                <span *ngIf="banner.dt_expiracao && banner.dt_expiracao_days == 1">Expira Amanhã</span>
                <span *ngIf="banner.dt_expiracao && banner.dt_expiracao_days == 0">Expira Hoje</span>
                <span *ngIf="banner.dt_expiracao && banner.dt_expiracao_days == -1">Expirado</span>
                <span *ngIf="banner.diasemana != 0">{{getDayWeek(banner.diasemana)}}</span>
                <span class="tag tag-on" *ngIf="banner.publicado=='S'">Publicado</span>
                <span class="tag" *ngIf="banner.publicado=='N'">Inativo</span>
              </div>
            </div>
        </div>
    </div>
  </section>

  <div class="loading" *ngIf="loadingBanner">
    <div class="loadingio-spinner-eclipse-cz3y1wre1nd">
        <div class="ldio-ns36390yc">
            <div></div>
        </div>
    </div>
  </div>

  <div class="actions" [class.dflex]="changed">
    <span>Salvar as alterações</span>
    <div>
      <button (click)="onCancel()" class="btn btn-primary-outline">Cancelar</button>
      <button (click)="onSubmit()" class="btn btn-primary">Salvar</button>
    </div>
  </div>
</div>
